// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Color = require("../Chip.Model.Color/index.js");
var Chip_Model_DieReason = require("../Chip.Model.DieReason/index.js");
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Chip_Model_Enemy = require("../Chip.Model.Enemy/index.js");
var Chip_Model_Item = require("../Chip.Model.Item/index.js");
var Chip_Model_Level = require("../Chip.Model.Level/index.js");
var Chip_Model_State = require("../Chip.Model.State/index.js");
var Chip_Model_SwitchState = require("../Chip.Model.SwitchState/index.js");
var Chip_Model_Tile = require("../Chip.Model.Tile/index.js");
var Chip_Model_WallType = require("../Chip.Model.WallType/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Floor = (function () {
    function Floor() {

    };
    Floor.value = new Floor();
    return Floor;
})();
var Tile = (function () {
    function Tile(value0) {
        this.value0 = value0;
    };
    Tile.create = function (value0) {
        return new Tile(value0);
    };
    return Tile;
})();
var Boy = (function () {
    function Boy(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Boy.create = function (value0) {
        return function (value1) {
            return new Boy(value0, value1);
        };
    };
    return Boy;
})();
var Creature = (function () {
    function Creature(value0) {
        this.value0 = value0;
    };
    Creature.create = function (value0) {
        return new Creature(value0);
    };
    return Creature;
})();
var Swimming = (function () {
    function Swimming(value0) {
        this.value0 = value0;
    };
    Swimming.create = function (value0) {
        return new Swimming(value0);
    };
    return Swimming;
})();
var DrownBoy = (function () {
    function DrownBoy() {

    };
    DrownBoy.value = new DrownBoy();
    return DrownBoy;
})();
var BurnedBoy = (function () {
    function BurnedBoy() {

    };
    BurnedBoy.value = new BurnedBoy();
    return BurnedBoy;
})();
var Block = (function () {
    function Block() {

    };
    Block.value = new Block();
    return Block;
})();
var rangeSlice = function (r) {
    return function (v) {
        var d = (2 * r | 0) + 1 | 0;
        var from = function (c) {
            return Data_Ord.max(Data_Ord.ordInt)(0)(Data_Ord.min(Data_Ord.ordInt)(Data_Ord.max(Data_Ord.ordInt)(0)(c - r | 0))(Chip_Model_Level.mapSize - d | 0));
        };
        var to = function (c) {
            return Data_Ord.min(Data_Ord.ordInt)(Chip_Model_Level.mapSize - 1 | 0)((d + from(c) | 0) - 1 | 0);
        };
        var xRange = Data_Array.range(from(v.x))(to(v.x));
        return Data_Functor.map(Data_Functor.functorArray)(Data_Function.flip(Data_Tuple.Tuple.create)(xRange))(Data_Array.range(from(v.y))(to(v.y)));
    };
};
var directionSuffix = function (v) {
    if (v instanceof Chip_Model_Direction.Left) {
        return " -left";
    };
    if (v instanceof Chip_Model_Direction.Up) {
        return " -up";
    };
    if (v instanceof Chip_Model_Direction.Right) {
        return " -right";
    };
    if (v instanceof Chip_Model_Direction.Down) {
        return " -down";
    };
    throw new Error("Failed pattern match at Display (line 139, column 19 - line 143, column 19): " + [ v.constructor.name ]);
};
var tileClasses = function (v) {
    if (v instanceof Floor) {
        return "tile -floor";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Wall && v.value0.value0 instanceof Chip_Model_WallType.Solid)) {
        return "tile -wall";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Wall && v.value0.value0 instanceof Chip_Model_WallType.Invisible)) {
        return "tile -floor";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Wall && v.value0.value0 instanceof Chip_Model_WallType.Hidden)) {
        return "tile -floor";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Wall && v.value0.value0 instanceof Chip_Model_WallType.Blue)) {
        return "tile -wall -blue";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Wall && v.value0.value0 instanceof Chip_Model_WallType.Fake)) {
        return "tile -wall -blue";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Wall && v.value0.value0 instanceof Chip_Model_WallType.Recessed)) {
        return "tile -wall -recessed";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Wall && v.value0.value0 instanceof Chip_Model_WallType.Flat)) {
        return "tile -wall" + directionSuffix(v.value0.value0.value0);
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Thief) {
        return "tile -thief";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Teleport) {
        return "tile -teleport";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Chip) {
        return "tile -chip";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Door && v.value0.value0 instanceof Chip_Model_Color.Red)) {
        return "tile -door -red";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Door && v.value0.value0 instanceof Chip_Model_Color.Cyan)) {
        return "tile -door -cyan";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Door && v.value0.value0 instanceof Chip_Model_Color.Yellow)) {
        return "tile -door -yellow";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Door && v.value0.value0 instanceof Chip_Model_Color.Green)) {
        return "tile -door -green";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Force) {
        return "tile -force" + directionSuffix(v.value0.value0);
    };
    if (v instanceof Boy) {
        return tileClasses(v.value1) + (" -boy" + (directionSuffix(v.value0) + "-creature"));
    };
    if (v instanceof Creature && v.value0 instanceof Chip_Model_Enemy.Bee) {
        return "tile -bee" + directionSuffix(v.value0.value0);
    };
    if (v instanceof Creature && v.value0 instanceof Chip_Model_Enemy.Teeth) {
        return "tile -teeth" + directionSuffix(v.value0.value0);
    };
    if (v instanceof Creature && v.value0 instanceof Chip_Model_Enemy.Glider) {
        return "tile -glider" + directionSuffix(v.value0.value0);
    };
    if (v instanceof Creature && v.value0 instanceof Chip_Model_Enemy.Tank) {
        return "tile -tank" + directionSuffix(v.value0.value0);
    };
    if (v instanceof Creature && v.value0 instanceof Chip_Model_Enemy.Ball) {
        return "tile -ball";
    };
    if (v instanceof Creature && v.value0 instanceof Chip_Model_Enemy.FireBall) {
        return "tile -fireball";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.CloneMachine) {
        return "tile -clone-machine";
    };
    if (v instanceof Block) {
        return "tile -block";
    };
    if (v instanceof Swimming) {
        return "tile -swimming" + (directionSuffix(v.value0) + "-creature");
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Bomb) {
        return "tile -bomb";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Water) {
        return "tile -water";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Fire) {
        return "tile -fire";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Ice) {
        return "tile -ice";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.IceCorner) {
        return "tile -ice -corner" + directionSuffix(v.value0.value0);
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Item && (v.value0.value0 instanceof Chip_Model_Item.Key && v.value0.value0.value0 instanceof Chip_Model_Color.Red))) {
        return "tile -key -red";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Item && (v.value0.value0 instanceof Chip_Model_Item.Key && v.value0.value0.value0 instanceof Chip_Model_Color.Cyan))) {
        return "tile -key -cyan";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Item && (v.value0.value0 instanceof Chip_Model_Item.Key && v.value0.value0.value0 instanceof Chip_Model_Color.Yellow))) {
        return "tile -key -yellow";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Item && (v.value0.value0 instanceof Chip_Model_Item.Key && v.value0.value0.value0 instanceof Chip_Model_Color.Green))) {
        return "tile -key -green";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Item && v.value0.value0 instanceof Chip_Model_Item.SkiSkates)) {
        return "tile -ski-skates";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Item && v.value0.value0 instanceof Chip_Model_Item.SuctionBoots)) {
        return "tile -suction-boots";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Item && v.value0.value0 instanceof Chip_Model_Item.FireBoots)) {
        return "tile -fire-boots";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.Item && v.value0.value0 instanceof Chip_Model_Item.Flippers)) {
        return "tile -flippers";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.SwitchableWall && v.value0.value0 instanceof Chip_Model_SwitchState.On)) {
        return "tile -switchable-wall -on";
    };
    if (v instanceof Tile && (v.value0 instanceof Chip_Model_Tile.SwitchableWall && v.value0.value0 instanceof Chip_Model_SwitchState.Off)) {
        return "tile -switchable-wall -off";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.WallButton) {
        return "tile -wall-button";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.TankButton) {
        return "tile -tank-button";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.CloneMachineButton) {
        return "tile -clone-machine-button";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Exit) {
        return "tile -exit";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Dirt) {
        return "tile -dirt";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Gravel) {
        return "tile -gravel";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Hint) {
        return "tile -hint";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Socket) {
        return "tile -socket";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.Trap) {
        return "tile -trap";
    };
    if (v instanceof Tile && v.value0 instanceof Chip_Model_Tile.TrapButton) {
        return "tile -trap-button";
    };
    if (v instanceof DrownBoy) {
        return "tile -drown";
    };
    if (v instanceof BurnedBoy) {
        return "tile -burned";
    };
    throw new Error("Failed pattern match at Display (line 52, column 15 - line 109, column 30): " + [ v.constructor.name ]);
};
var tileToElem = function (tile) {
    return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_(tileClasses(tile)) ])([  ]);
};
var tilesRowElem = function (tiles) {
    return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("level-row") ])(Data_Functor.map(Data_Functor.functorArray)(tileToElem)(tiles));
};
var buildTile = function (p) {
    return function (v) {
        var tile = Data_Maybe.maybe(Floor.value)(Tile.create)(Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(p)(v.level.tiles));
        if (Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Eq.eqInt)))(p)(v.level.player.pos)) {
            if (v.state instanceof Chip_Model_State.Dead && v.state.value0 instanceof Chip_Model_DieReason.Drown) {
                return DrownBoy.value;
            };
            if (v.state instanceof Chip_Model_State.Dead && v.state.value0 instanceof Chip_Model_DieReason.Burned) {
                return BurnedBoy.value;
            };
            if (tile instanceof Tile && tile.value0 instanceof Chip_Model_Tile.Water) {
                return new Swimming(v.level.player.direction);
            };
            return new Boy(v.level.player.direction, tile);
        };
        if (Data_Set.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(p)(v.level.blocks)) {
            return Block.value;
        };
        return Data_Maybe.maybe(tile)(Creature.create)(Chip_Model_Level.enemyAt(p)(v.level));
    };
};
var levelTiles = function (game) {
    return Data_Functor.map(Data_Functor.functorArray)(function (v) {
        return Data_Functor.map(Data_Functor.functorArray)(function (x) {
            return buildTile({
                x: x,
                y: v.value0
            })(game);
        })(v.value1);
    })(rangeSlice(game.radius)(game.level.player.pos));
};
module.exports = {
    Floor: Floor,
    Tile: Tile,
    Boy: Boy,
    Creature: Creature,
    Swimming: Swimming,
    DrownBoy: DrownBoy,
    BurnedBoy: BurnedBoy,
    Block: Block,
    levelTiles: levelTiles,
    tilesRowElem: tilesRowElem
};
